import * as React from "react";
import { Alert } from "antd";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { useCanRenderAdvanced } from "./useCanRenderAdvanced";
import { Gvc } from "../../../../schema/types/gvc/entity";

interface Props {}
export const AcceptAllDedicatedLBCheck: React.FC<Props> = () => {
  const canRender = useCanRenderAdvanced();
  const acceptAll = useCpFormValue("advanced.spec.acceptAll");
  const gvcItem: Gvc = useCpFormValue(`gvc.item`);

  if (!canRender) {
    return null;
  }

  if (gvcItem?.spec?.loadBalancer?.dedicated) {
    if (acceptAll === "hosts") {
      return (
        <Alert
          showIcon
          type={`success`}
          className="w-fit"
          message={`Dedicated Load Balancer is Already Set`}
          description={`Domain with "acceptAllHosts" value set to true requires Dedicated Load Balancer on the GVC that it is targeting, and for this GVC it is already set`}
        />
      );
    }

    if (acceptAll === "subdomains") {
      return (
        <Alert
          showIcon
          type={`success`}
          className="w-fit"
          message={`Dedicated Load Balancer is Already Set`}
          description={`Domain with "acceptAllSubdomains" value set to true requires Dedicated Load Balancer on the GVC that it is targeting, and for this GVC it is already set`}
        />
      );
    }
  }

  if (acceptAll === "hosts") {
    return (
      <Alert
        showIcon
        type={`warning`}
        className="w-fit"
        message={`Dedicated Load Balancer is Required`}
        description={`Domain with "acceptAllHosts" value set to true requires Dedicated Load Balancer on the GVC that it is targeting`}
      />
    );
  }

  if (acceptAll === "subdomains") {
    return (
      <Alert
        showIcon
        type={`warning`}
        className="w-fit"
        message={`Dedicated Load Balancer is Required`}
        description={`Domain with "acceptAllSubdomains" value set to true requires Dedicated Load Balancer on the GVC that it is targeting`}
      />
    );
  }

  return null;
};
